import { Link } from "react-router-dom"

export default function UIHelpCard({ icon, title, link = null, description, className }) {
    return (
        <div className={`flex flex-col text-center justify-start items-center gap-2 py-5 mx-auto max-w-[280px] ${className} md:w-[32%]`}>
            <img src={icon} alt="helpCard" className="w-[40px] h-[35px] p-1" />
            <div className="text-[16px] font-BNPPSquareBold text-secondary-green mb-2">{title}</div>
            <div className="text-[#58595B] shrink-0 font-OpenSans text-[14px] px-2 flex flex-col ">
                {link !== null && <Link to={link}>
                    {description.split('/n').map((item) => (
                        <p className="hover:underline inline no-underline" key={item}>{item}</p>
                    ))}
                </Link>}
                {link === null && description.split('/n').map((item) => (
                    <p className="" key={item}>{item}</p>
                ))
                }
            </div>
        </div>
    )
} 